import type { UserService } from '@blocksuite/affine-shared/services';
import { useEffect } from 'react';

import { useSignalValue } from '../../../modules/doc-info/utils';

export const useMemberInfo = (
  id: string,
  userService: UserService | null | undefined
) => {
  const currentUser = useSignalValue(userService?.currentUserInfo$);
  useEffect(() => {
    userService?.revalidateUserInfo(id);
  }, [id, userService]);
  const userInfo = useSignalValue(userService?.userInfo$(id));
  if (userInfo) {
    return userInfo;
  }
  if (currentUser?.id === id) {
    return currentUser;
  }
  return null;
};
